<h2 mat-dialog-title>Sendungsprotokoll</h2>
<mat-dialog-content>
  <p>Hier können Sie prüfen, welche Belege erfolgreich übertragen worden sind bzw. ob es Fehler gab.</p>

  @if (data.logs && data.logs.length > 0) {
    <table mat-table [dataSource]="data.logs" class="mat-elevation-z2">

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let log">
          <mat-icon fontSet="material-symbols-outlined" color="neutral"
                    aria-hidden="false">{{ log.status === 'SUCCESS' ? 'check_circle' : 'cancel' }}
          </mat-icon>
        </td>
      </ng-container>

      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Datum</th>
        <td mat-cell *matCellDef="let log">{{ log.date | date:'short' }}</td>
      </ng-container>

      <!-- Message Column -->

      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef>Kommentar</th>
        <td mat-cell *matCellDef="let log">
          @if (log.status === 'SUCCESS') {
            {{ getType(log.type) }} {{ log.document }} wurde erfolgreich übertragen.
          } @else if (log.status === 'FAILURE') {
            {{ getType(log.type) }} {{ log.document }} wurde nicht übertragen.
          } @else {
            Keine Informationen
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  } @else {
    <div class="no-data">
      <p class="mt-l"><em>Keine Sendungsprotokollinformationen verfügbar.</em></p>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onClose()">Schließen</button>
</mat-dialog-actions>
